import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { TravelExpensesAffectedStaffDetailsPage } from './travel-expenses-affect-staff-details'
import { TravelExpensesListPage } from './travel-expenses-list'
import { TravelExpensesMissionToStaffDetailsPage } from './travel-expenses-mission-to-staff-details'
import TravelExpensesSalaryStaffsListPage from './travel-expenses-salary-staffs-list'

const travelExpensesRoutes: Route[] = [
  {
    path: Paths.STAFF_EXPENSE_REPORT_LIST_PAGE,
    element: <TravelExpensesListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.AFFECTED_STAFF_EXPENSE_REPORT_DETAILS_PAGE,
    element: <TravelExpensesAffectedStaffDetailsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_TO_STAFF_EXPENSE_REPORT_DETAILS_PAGE,
    element: <TravelExpensesMissionToStaffDetailsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRAVEL_EXPENSES_STAFF_SALARY_LIST_PAGE,
    element: <TravelExpensesSalaryStaffsListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default travelExpensesRoutes
